enum ColorEnums {
  AMETHYST100 = '#895ACC',

  BLACK10 = '#E8E9EB',
  BLACK100 = '#1E2B37',
  BLACK20 = '#D2D5D7',
  BLACK200 = '#000011',
  BLACK40 = '#A5AAAF',
  BLACK5 = '#F4F4F5',
  BLACK60 = '#5A738B',
  BLACK80 = '#4B555F',

  BLUE10 = '#E6ECF5',
  BLUE100 = '#0D47A1',
  BLUE2 = '#F9FAFC',
  BLUE20 = '#CFDAEC',
  BLUE200 = '#072A60',
  BLUE5 = '#F3F6FA',
  BLUE50 = '#86A3D0',
  BLUE80 = '#3D6CB4',

  GREEN10 = '#EBF6F5',
  GREEN100 = '#3EA69B',
  GREEN20 = '#D8EDEB',
  GREEN200 = '#2B897C',

  ORANGE10 = '#FFEEE5',
  ORANGE100 = '#FF5500',
  ORANGE20 = '#FFBB99',
  ORANGE200 = '#CC4400',
  ORANGE40 = '#FF9966',
  ORANGE70 = '#FF7733',

  PERSIAN_GREEN100 = '#00A69C',

  PURPLE10 = '#F7F0F7',
  PURPLE100 = '#B370B0',

  RED10 = '#FAE5E5',
  RED100 = '#D50000',
  RED20 = '#F7CCCC',
  RED200 = '#9B0000',
  RED5 = '#FDF2F2',
  RED70 = '#E14C4C',
  RED80 = '#DD3333',

  TOSCA100 = '#0DBCE8',

  WHITE = '#FFFFFF',

  YELLOW10 = '#FEFAED',
  YELLOW100 = '#F7D250',
  YELLOW20 = '#FDF8E1',
  YELLOW200 = '#C1A119',
  YELLOW40 = '#FBEAB3',
  YELLOW70 = '#F9DF84',

  VIOLET200 = '#1D0D44',
  VIOLET100 = '#321877',
  VIOLET80 = '#6949C0',
  VIOLET50 = '#A591D9',
  VIOLET20 = '#C3B6E6',
  VIOLET10 = '#DBD3F0',
  VIOLET5 = '#F4F0FB',
  VIOLET2 = '#FCFAFE',
}

export default ColorEnums;
